<section class="information-wrapper">
  <section class="section-wrapper">
    <section class="section-content">
      <ul>
        <li *ngFor="let citation of data; let i = index">
          <div style="display: flex;">
            <div>
              <gen-button [type]="'emphasis'"
                          [iconClass]="'icon__Cross2'"
                          (click)="removeCitation(i)">
              </gen-button>
            </div>
            <div class="citation-display"><a href="javascript:void(0)" (click)="navigate(citation.code)">{{ citation.display }}</a></div>
          </div>
        </li>
      </ul>
    </section>
  </section>
</section>
